<template>
  <div>
    <div class="refund-style">
      <div class="refund-style-padding">
        <div class="order-amount">
            <!-- <van-field
            v-model="postModel.reconcileVo.PAY_AMOUNT"
            type="number"
            readonly
            input-align="right"
            label="订单金额"
          /> -->
          <span>订单金额</span>
          <span>¥ {{this.abs(postModel.reconcileVo.PAY_AMOUNT)}}</span>
        </div>
        <div class="order-info">
          <p class="info-title">退款信息</p>
          <p class="info-bot"></p>
          <div class="info-cont">
            <van-form class="info-form" ref="refundForm">
              <div>
                <span class="title-label">退款金额<i>*</i></span>
                <div class="info-input">
                  <i>￥</i>
                  <van-field
                    v-model="postModel.refundModel.AMOUNT"
                    placeholder="请输入"
                    type="number"
                    :rules="amountRules"
                    @blur="nameBlur"
                  />
                </div>
              </div>
              <div>
                <span class="title-label">退款类型<i>*</i></span>
                <div class="info-input info-input-new">
                  <van-field
                    v-model="postModel.refundModel.REFUND_TYPE"
                    readonly
                    placeholder="请输入"
                    @click="selectPopupData('refundTypeList', 'REFUND_TYPE', 1)"
                    :rules="[{ required: true, message: '请选择退款类型' }]"
                  />
                </div>
              </div>
              <div>
                <span class="title-label">退款原因<i>*</i></span>
                <div class="info-input info-input-new">
                  <van-field
                    v-model="postModel.refundModel.REFUND_REASON"
                    placeholder="请输入"
                    :rules="[{ required: true, message: '请输入退款原因' }]"
                  />
                </div>
              </div>
              <div v-if="postModel.refundModel.REFUND_TYPE == '项目终止退款'">
                <span class="title-label">退款流程<i>*</i></span>
                <div class="info-input info-input-new">
                  <van-field
                    v-model="postModel.refundModel.REFUND_PROCESS_NAME"
                    readonly
                    placeholder="请输入"
                    @click="
                      postModel.reconcileVo.CONTRACT_TYPE == 2
                        ? selectPopupData(
                            'refundProcessList',
                            'REFUND_PROCESS',
                            2
                          )
                        : ''
                    "
                    :rules="[{ required: postModel.refundModel.REFUND_TYPE == '项目终止退款'?true:false, message: '请选择退款流程' }]"
                  />
                </div>
              </div>
              <div v-if="postModel.refundModel.REFUND_PROCESS == 1 && postModel.refundModel.REFUND_TYPE == '项目终止退款'">
                <span class="title-label">已提供的检测服务为<i>*</i></span>
                <div class="info-input info-input-new">
                  <van-field
                    v-model="postModel.refundModel.RESTING_SERVICES"
                    placeholder="请输入"
                    :rules="[
                      { required:postModel.refundModel.REFUND_TYPE == '项目终止退款'?true:false, message: '请输入已提供的检测服务为' },
                    ]"
                  />
                </div>
              </div>
              <div>
                <span class="title-label">退款方式<i>*</i></span>
                <div
                  :class="{
                    'info-input': true,
                    'info-input-new': true,
                  }"
                >
                  <van-field
                    v-model="postModel.refundModel.PAY_TYPE"
                    readonly
                    placeholder="请输入"
                    @click="postModel.reconcileVo.IS_CAN_YUANLU == 2? '': selectPopupData('refundMethodList', 'PAY_TYPE', 3)"
                    :rules="[{ required: true, message: '请选择退款方式' }]"
                  />
                </div>
              </div>
              <div v-if=" contract_type == 1 &&postModel.refundModel.PAY_TYPE.includes('银行转账')">
                  <span class="title-label">退款是否退回到受检者或委托人<i>*</i></span>
                  <div class="info-input info-input-new">
                    <!-- <van-radio-group v-model="postModel.refundModel.IS_REFUND_ONESELF" style="display: flex;justify-content: space-around;padding-top: 20px;padding-bottom: 20px;font-size:13px">
                      <van-radio @click="isSelect_y"  name="1">是</van-radio>
                      <van-radio @click="isSelect_n" name="0">否</van-radio>
                    </van-radio-group> -->
                    <div class="cost_reson" style="margin-top:20px;margin-bottom:20px">
                      <button
                        :class="postModel.refundModel.IS_REFUND_ONESELF === item.id ? 'isChecked' : ' '"
                        v-for="(item, index) in costinvoiceType"
                        :key="index"
                        @click="invoiceIndexHandle(item, index)"
                      >
                        {{ item.value }}
                      </button>
                    </div>
                  </div>
               </div>
              <div v-if="postModel.refundModel.PAY_TYPE.includes('银行转账')">
                <div>
                  <span class="title-label">收款人姓名<i>*</i></span>
                  <div class="info-input info-input-new">
                    <van-field
                      v-model="postModel.refundModel.PAY_ACCOUNT"
                      placeholder="请输入"
                      :rules="[{ required: true, message: '请输入收款人姓名' }]"
                      @blur="onblur"
                    />
                  </div>
                </div>
                <div>
                  <span class="title-label">收款银行账号<i>*</i></span>
                  <div class="info-input info-input-new">
                    <van-field
                      v-model="postModel.refundModel.BANK_NO"
                      placeholder="请输入"
                      :rules="[
                        { required: true, message: '请输入收款银行账号' },
                      ]"
                    />
                    <span class="iconfont icon-saoyisao" @click="saoyisaoHandle"></span>
                  </div>
                </div>
                <div>
                  <span class="title-label">开户银行全称<i>*</i></span>
                  <div class="info-input info-input-new">
                    <van-field
                      v-model="postModel.refundModel.PAY_BANK"
                      placeholder="开户银行全称(务必详细到省市支行)"
                      :rules="[
                        { required: true, message: '请输入开户银行全称' },
                      ]"
                    />
                  </div>
                </div>
                <div v-if="postModel.refundModel.IS_REFUND_ONESELF == '1'&&postModel.order.CONTRACT_TYPE=='1'">
                  <span class="title-label">纸质合同<i>*</i></span>
                  <div class="info-input info-input-new info-input-upload">
                    <div class="upload-list">
                      <div
                        v-for="(item, index) in postModel.refundContractPath"
                        :key="'img_' + index"
                        class="imgArrClass"
                      >
                        <van-image :src="item.url" />
                        <i
                          class="deleteImgStyle"
                          style="top: 0"
                          @click="deleteImg(item)"
                          >X</i>
                      </div>
                      <div class="upload-btn" @click="afterReadFun(9)">
                        <span class="iconfont icon-shangchuantupian"></span>
                        <span>上传附件</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="is_show_enclosure == true||postModel.refundModel.IS_REFUND_ONESELF == '0'">
                  <span class="title-label">死亡证明<i>*</i></span>
                  <div class="info-input info-input-new info-input-upload">
                    <div class="upload-list">
                      <div
                        v-for="(item, index) in postModel.deathFilePath"
                        :key="'img_' + index"
                        class="imgArrClass"
                      >
                        <van-image :src="item.url" />
                        <i
                          class="deleteImgStyle"
                          style="top: 0"
                          @click="deleteImg(item)"
                          >X</i>
                      </div>
                      <div class="upload-btn" @click="afterReadFun(6)">
                        <span class="iconfont icon-shangchuantupian"></span>
                        <span>上传附件</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="is_show_enclosure == true||postModel.refundModel.IS_REFUND_ONESELF == '0'">
                  <span class="title-label">关系证明<i>*</i></span>
                  <div class="info-input info-input-new info-input-upload">
                    <div class="upload-list">
                      <div
                        v-for="(item, index) in postModel.relationshipFilePath"
                        :key="'img_' + index"
                        class="imgArrClass"
                      >
                        <van-image :src="item.url" />
                        <i
                          class="deleteImgStyle"
                          style="top: 0"
                          @click="deleteImg(item)"
                          >X</i>
                      </div>
                      <div class="upload-btn" @click="afterReadFun(7)">
                        <span class="iconfont icon-shangchuantupian"></span>
                        <span>上传附件</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendRequest } from "../../../api/order";
import { Toast } from "vant";
import isiOS from "../../../utils/iosAn";
export default {
  name: "",
  data() {
    return {
      orderCode: "",
      // disabled:false,
      contract_type:'',
      postModel: {
        reconcileVo: {
          PAY_AMOUNT: "",
        },
        refundModel: {
          REFUND_PROCESS: "",
          PAY_TYPE: "",
          IS_REFUND_ONESELF:'1',
        },
        deathFilePath: [], // 上传文件路径
      },
      amountRules: [
        {
          required: true,
          message: "请输入退款金额",
          trigger: "onBlur",
        },
        {
          // 自定义校验规则
          validator: (value) => {
            //退款金额需小于对账金额
            return (
              Number(this.postModel.reconcileVo.PAY_AMOUNT) >= Number(value)
            );
          },
          message: "退款金额需小于对账金额！",
          trigger: "onBlur",
        },
      ],
      costinvoiceType: [
        { id: "1", value: "是" },
        { id: "0", value: "否" },
      ],
      refundTypeList: [
        { label: "项目终止退款", value: "项目终止退款" },
        { label: "更换产品退款", value: "更换产品退款" },
        { label: "收款金额有误，退差价", value: "收款金额有误，退差价" },
      ], //退款类型
      refundProcessList: [
        { label: "小程序(用户确认申请)", value: 1 },
        { label: "线下退款(销售上传申请附件)", value: 2 },
      ], //退款流程
      refundMethodList: [
        { label: "退回原账户", value: "退回原账户" },
        { label: "银行转账", value: "银行转账" },
      ], //退款方式
      selectData: {
        list: [],
        checkVal: "",
        selectValue: "", //当前选中的项
        showSelector: false,
      },
      is_show_enclosure:false //是否显示附件
    };
  },
  components: {},
  created() {
    var result = this.getUrlParams(location.href);
    console.log(result,'log');
    this.orderCode = result.orderCode;
  },
  mounted() {
    this.getOrderDetail();
    //拿app 的返回值
    window.NativeCallJS = (res) => {
      var _data = JSON.parse(res);
      console.log(_data,'logs')
      if(_data.bankCard){
        this.postModel.refundModel.BANK_NO = _data.bankCard.replaceAll(' ', '')
      }
      if (_data.buttonType=='3') {
      this.deleteRefund()
      }
      if (_data.submit == true) {
        this.onSubmit();
      } else if (_data.save == true) {
        this.saveData();
      } else if (_data.type == 1) {
        //退款类型
        this.$set(this.postModel.refundModel, "REFUND_TYPE", _data.path);
        // this.$set(this.postModel.refundModel, "REFUND_REASON", _data.path);
      } else if (_data.type == 2) {
        //退款流程
        if (_data.path.indexOf("小程序") > -1) {
          this.$set(this.postModel.refundModel, "REFUND_PROCESS", 1);
          this.$set(this.postModel.refundModel, "REFUND_PROCESS_NAME", _data.path);
        } else {
          this.$set(this.postModel.refundModel, "REFUND_PROCESS", 2);
          this.$set(this.postModel.refundModel, "REFUND_PROCESS_NAME", _data.path);
        }
      } else if (_data.type == 3) {
        // 退款方式
        this.$set(this.postModel.refundModel, "PAY_TYPE", _data.path);
      } else if (_data.type == 6 || _data.type == 7 || _data.type == 8 || _data.type == 9) {
        this.afterRead(_data);
      }
    };
  },
  methods: {
      saoyisaoHandle(){
        if (isiOS) {
            window.webkit.messageHandlers.JSCallNative.postMessage({
              bankCard:1
            });
          } else {
            window.android.JSCallNative(JSON.stringify({ bankCard:1 }));
        }
      },
      //删除退款
      async deleteRefund(){
        let _data = {
          requestType: "GET",
          url: "/refund/deleteRefund",
          params: { id: this.postModel.refundModel.ID},
          isBody: true,
          body: {},
        };
        let { data, code } = await sendRequest(_data);
        if(code === 20000){
          if (isiOS) {
            window.webkit.messageHandlers.JSCallNative.postMessage({
              message:1
            });
          } else {
            window.android.JSCallNative(JSON.stringify({ message:1 }));
          }
        }else{
          if (isiOS) {
            window.webkit.messageHandlers.JSCallNative.postMessage({
              message:2
            });
          } else {
            window.android.JSCallNative(JSON.stringify({ message:2 }));
          }
        }
      },
      // 金额 格式化
      abs(value) {  
        if (!value && value !== 0) return '';
        var intPart = Number(value) | 0; //获取整数部分
        var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{})+$)/g, '$1,'); //将整数部分逢三一断
    
        var floatPart = ".00"; //预定义小数部分
        var value2Array = value.toString().split(".");
    
        //=2表示数据有小数位
        if (value2Array.length == 2) {
            floatPart = value2Array[1].toString(); //拿到小数部分
    
            if (floatPart.length == 1) { //补0,实际上用不着
                return intPartFormat + "." + floatPart + '0';
            } else {
                return intPartFormat + "." + floatPart;
            }
        } else {
            return intPartFormat + floatPart;
        }
    },
    nameBlur(){
      this.postModel.refundModel.AMOUNT=this.abs(this.postModel.refundModel.AMOUNT)
    },
      invoiceIndexHandle(item, index) {
        this.postModel.refundModel.IS_REFUND_ONESELF =item.id
        if(this.postModel.refundModel.IS_REFUND_ONESELF==1){
          this.postModel.refundModel.PAY_ACCOUNT=this.postModel.name
        }else{
           this.postModel.refundModel.PAY_ACCOUNT=''
           this.postModel.refundModel.BANK_NO=''
           this.postModel.refundModel.PAY_BANK=''
        }
      },
     isSelect_y(){
      this.postModel.refundModel.PAY_ACCOUNT=this.postModel.name
    },
    isSelect_n(){
      this.postModel.refundModel.PAY_ACCOUNT=''
    },
    // 取url参数
    getUrlParams(url) {
      let urlStr = url.split("?")[1];
      const urlSearchParams = new URLSearchParams(urlStr);
      const result = Object.fromEntries(urlSearchParams.entries());
      return result;
    },
    // 姓名失去焦点
    onblur(){
      console.log(this.postModel.refundModel.PAY_ACCOUNT)
      console.log(this.postModel.name)
      console.log(this.postModel)
       if (this.postModel.order.CONTRACT_TYPE=='1') {
         if (this.postModel.refundModel.PAY_ACCOUNT==this.postModel.name||this.postModel.refundModel.PAY_ACCOUNT==this.postModel.entrustedName) {
          // this.disabled =false
        }else{
          // this.postModel.refundModel.IS_REFUND_ONESELF ='0'
          // this.disabled =true
        } 
       }else{
         if(this.postModel.refundModel.PAY_ACCOUNT==this.postModel.name){// 受检者本人 
          //不上传
           this.is_show_enclosure = false
        }else if(this.postModel.refundModel.PAY_ACCOUNT==this.postModel.entrustedName){//输入的名字等于委托测序者
          //不上传
          this.is_show_enclosure = false
        }else if(
                this.postModel.name && this.postModel.entrustedName &&
                this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.name &&
                this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.entrustedName){ //受检者和委托测序者都有并且输入的名字与他们不想等
          //不上传加返回
          this.is_show_enclosure = false
          Toast('退款只能退给受检者或者委托人。');
          return
        }else if(!this.postModel.entrustedName && this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.name){//委托测序者为空，并且输入的名字不等于受检者
          //上传
          this.is_show_enclosure = true 
            if(this.postModel.relationshipFilePath&&this.postModel.relationshipFilePath.length==0){
              Toast('请上传关系证明');
            return 
            }
            if(this.postModel.deathFilePath&&this.postModel.deathFilePath.length==0){
              Toast('请上传死亡证明');
              return 
            }
        }
       }
    },
    //统一调用的接口方法
    async getSendRequest(_data) {
      let { data } = await sendRequest({
        requestType: _data.type, //接口 是 get 还是post
        url: _data.url, //接口地址
        params: _data.paramsData, //get 接口的参数
        isBody: _data.isBody, // 必填get传false ,post传true
        body: _data.bodyData, //post 接口的参数
      });
      return data;
    },
    //从订单详情进入调用接口
    getOrderDetail() {
      let _data = {
        type: "GET",
        url: "/refund/appSave",
        paramsData: { orderCode: this.orderCode },
        isBody: false,
        bodyData: {},
      };
      this.voDetailData(_data);
    },
    //保存接口
    async getSaveDetail() {
      let _data = {
        type: "POST",
        url: "/refund/saveOrUpdate",
        paramsData: {},
        isBody: true,
        bodyData: { ...this.postModel },
      };
      await this.getRefundView(await this.getSendRequest(_data));
    },
    //页面刷新接口
    async getRefundView(id) {
      let _data = {
        type: "get",
        url: "/refund/view",
        paramsData: { ID: id },
        isBody: false,
        bodyData: {},
      };
      await this.voDetailData(_data);
    },
    //接口返回值更新
    async voDetailData(_data) {
      this.postModel = await this.getSendRequest(_data);
      // console.log(this.postModel,'11')
      // console.log(this.postModel)
      // 根据详情接口查受检者姓名判断是否要展示上传附件
      if (this.postModel.reconcileVo.PAY_AMOUNT == null) {
        this.postModel.reconcileVo.PAY_AMOUNT = "";
      } else {
        if (this.postModel.refundModel.REFUND_PROCESS == 1) {
          this.postModel.refundModel.REFUND_PROCESS_NAME = "小程序(用户确认申请)";
        } else if (this.postModel.refundModel.REFUND_PROCESS == 2) {
          this.postModel.refundModel.REFUND_PROCESS_NAME = "线下退款(销售上传申请附件)";
        }
      }
      if (this.postModel.refundModel.REFUND_PROCESS == null) {
        this.postModel.refundModel.REFUND_PROCESS = "";
      }
      if(this.postModel.refundModel.PAY_TYPE == '' || this.postModel.refundModel.PAY_TYPE == null){
        if (this.postModel.reconcileVo.IS_CAN_YUANLU == 1) {
          this.postModel.refundModel.PAY_TYPE = "退回原账户";
          if(this.postModel.refundModel.PAY_ACCOUNT == '' || this.postModel.refundModel.PAY_ACCOUNT == null){
            this.postModel.refundModel.PAY_ACCOUNT = this.postModel.reconcileVo.NAME;
          }
        }else if(this.postModel.reconcileVo.IS_CAN_YUANLU == 2){
          this.postModel.refundModel.PAY_TYPE = "银行转账";
          if(this.postModel.refundModel.PAY_ACCOUNT == '' || this.postModel.refundModel.PAY_ACCOUNT == null){
            this.postModel.refundModel.PAY_ACCOUNT = this.postModel.reconcileVo.NAME;
          }
        }
      }
      // //电子订单可以选退款流程，纸质合同只能选线下
      // if (this.postModel.reconcileVo.CONTRACT_TYPE == 1) {
      //   //2:电子合同
      //   this.postModel.refundModel.REFUND_PROCESS = 2;
      //   this.postModel.refundModel.REFUND_PROCESS_NAME =
      //     "线下退款(销售上传申请附件)";
      // } else {
      //   this.postModel.refundModel.REFUND_PROCESS = "";
      // }
      if (this.postModel.order.CONTRACT_TYPE=='1') {
        this.postModel.refundModel.REFUND_PROCESS = 2;
        this.postModel.refundModel.REFUND_PROCESS_NAME =
          "线下退款(销售上传申请附件)";
        console.log('纸质合同')
        console.log(this.postModel.name,'受检者')
        console.log(this.postModel.entrustedName,'委托人')
        if (this.postModel.refundModel.PAY_ACCOUNT==this.postModel.name) {
          // this.disabled =false
          // this.postModel.refundModel.IS_REFUND_ONESELF ='1'
        }else{
          // this.postModel.refundModel.IS_REFUND_ONESELF ='0'
          // this.disabled =true
        }
        this.costinvoiceType.forEach((ele)=>{
          if(ele.id==this.postModel.refundModel.IS_REFUND_ONESELF){
            ele.id =this.postModel.refundModel.IS_REFUND_ONESELF
          }
        })
        console.log(this.postModel.refundModel.IS_REFUND_ONESELF)
      } else {
        this.postModel.refundModel.REFUND_PROCESS = "";
        console.log('电子合同')
        console.log(this.postModel.name,'受检者')
        console.log(this.postModel.entrustedName,'委托人')
        console.log(this.postModel.reconcileVo.NAME,'返回数据')
        console.log(this.postModel.refundModel.IS_REFUND_ONESELF)
        if (this.postModel.refundModel.PAY_ACCOUNT==this.postModel.name||this.postModel.refundModel.PAY_ACCOUNT==this.postModel.entrustedName) {
          this.is_show_enclosure = false
        } else if(
          this.postModel.name && this.postModel.entrustedName &&
          this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.name &&
          this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.entrustedName){
          this.is_show_enclosure = false
        }else {
          this.is_show_enclosure = true
        }
      }
      //获取上传的文件路径
      if(this.postModel.refundModel.ID != null && this.postModel.refundModel.ID != ''){ //保存之后调用
        this.postModel.deathFilePath = [];
        this.postModel.relationshipFilePath = [];
        this.postModel.refundContractPath = [];
        this.getSelectFilePath();
      }
      this.contract_type=this.postModel.order.CONTRACT_TYPE
      this.postModel.refundModel.AMOUNT = this.abs(this.postModel.refundModel.AMOUNT)
    },
    //上传后刷新
    async getSelectFilePath() {
      let _data = {
        type: "GET",
        url: "/refund/selectFilePath",
        paramsData: { orderId: this.postModel.refundModel.ID },
        isBody: false,
        bodyData: {},
      };
      let fileArr = await this.getSendRequest(_data);
      fileArr.deathFilePath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
      fileArr.relationshipFilePath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
      fileArr.refundContractPath.forEach((item) => {
        item.url = item.BASE_PATH + item.FILE_PATH;
      });
      
      this.$set(this.postModel, "deathFilePath", fileArr.deathFilePath);
      this.$set(this.postModel, "relationshipFilePath", fileArr.relationshipFilePath);
      this.$set(this.postModel, "refundContractPath", fileArr.refundContractPath);
    },
    //保存
    saveData() {
      console.log(21);
      this.getSaveDetail();
      Toast('保存成功')
    },
    //自动删除附件
    deleteAutoFile(){
      if (this.postModel.refundModel.PAY_TYPE.includes('银行转账')) {
      if (this.postModel.order.CONTRACT_TYPE=='2') {
        if (this.postModel.refundModel.PAY_ACCOUNT==this.postModel.name){ //电子情况下  受检者身份
          if (this.postModel.deathFilePath&&this.postModel.deathFilePath.length>0) {
          this.postModel.deathFilePath.forEach((item)=>{
            this.deleteImg(item)
          })  
          }
          if(this.postModel.relationshipFilePath&&this.postModel.relationshipFilePath.length>0){
            this.postModel.relationshipFilePath.forEach((item)=>{
            this.deleteImg(item)
          })
          }
        }
      }else{
        if (this.postModel.refundModel.IS_REFUND_ONESELF=='1') { 
          if (this.postModel.deathFilePath&&this.postModel.deathFilePath.length>0) {
          this.postModel.deathFilePath.forEach((item)=>{
            this.deleteImg(item)
          })  
          }
          if(this.postModel.relationshipFilePath&&this.postModel.relationshipFilePath.length>0){
            this.postModel.relationshipFilePath.forEach((item)=>{
            this.deleteImg(item)
          })
          }
        }else{
          if(this.postModel.refundContractPath&&this.postModel.refundContractPath.length>0){ 
            this.postModel.refundContractPath.forEach((item)=>{
            this.deleteImg(item)
          })
          }
        }
      }
      }
    },
    //提交
    onSubmit() {
      console.log(this.postModel)
      console.log(this.postModel.refundModel.IS_REFUND_ONESELF)
      console.log(this.postModel.refundModel.refundContractPath)
      if (this.postModel.refundModel.PAY_TYPE.includes('银行转账')) {
          if(this.postModel.order.CONTRACT_TYPE=='1'){
            if(this.postModel.refundModel.IS_REFUND_ONESELF==null){
                 Toast('请选择是否退回到受检者或委托人')
                  return
            }
            if(this.postModel.refundModel.IS_REFUND_ONESELF=='1'){
              console.log(this.postModel.refundModel.IS_REFUND_ONESELF)
              if (!this.postModel.refundContractPath ||this.postModel.refundContractPath&&this.postModel.refundContractPath.length==0) {
                  Toast('请上传纸质合同')
                  return
              }
            }else{
              console.log(this.postModel.refundModel.IS_REFUND_ONESELF)
              if (!this.postModel.relationshipFilePath ||this.postModel.relationshipFilePath&&this.postModel.relationshipFilePath.length==0) {
                  Toast('请上传关系证明')
                  return
              }
              if (!this.postModel.deathFilePath ||this.postModel.deathFilePath&&this.postModel.deathFilePath.length==0) {
                  Toast('请上传死亡证明')
                  return
              }
            }
          }else{
            console.log(this.postModel.refundModel.PAY_ACCOUNT) //输入的名字
            console.log(this.postModel.name)//受检者
            console.log(this.postModel.entrustedName)//委托测序者
            if(this.postModel.refundModel.PAY_ACCOUNT==this.postModel.name){// 受检者本人 
              //不上传
              this.is_show_enclosure = false
            }else if(this.postModel.refundModel.PAY_ACCOUNT==this.postModel.entrustedName){//输入的名字等于委托测序者
              //不上传
              this.is_show_enclosure = false
            }else if(
                    this.postModel.name && this.postModel.entrustedName &&
                    this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.name &&
                    this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.entrustedName){ //受检者和委托测序者都有并且输入的名字与他们不想等
              //不上传加返回
              this.is_show_enclosure = false
              Toast('退款只能退给受检者或者委托人。');
              return
            }else if(!this.postModel.entrustedName && this.postModel.refundModel.PAY_ACCOUNT!=this.postModel.name){//委托测序者为空，并且输入的名字不等于受检者
              //上传
              this.is_show_enclosure = true 
                if(this.postModel.relationshipFilePath&&this.postModel.relationshipFilePath.length==0){
                  Toast('请上传关系证明');
                return 
                }
                if(this.postModel.deathFilePath&&this.postModel.deathFilePath.length==0){
                  Toast('请上传死亡证明');
                  return 
                }
            }
          } 
      }

      this.$refs.refundForm
        .validate()
        .then(async () => {
          await this.deleteAutoFile()
          await this.getSaveDetail()
          let _data = {
            requestType: "POST",
            url: "/refund/save",
            params: {},
            isBody: true,
            body: { ...this.postModel },
          };
          console.log(1111)
         setTimeout(() => {
            if (this.postModel.refundModel.PAY_TYPE == "银行转账") {
            console.log(this.postModel.refundModel.PAY_TYPE)
            console.log(this.postModel.refundModel.PAY_ACCOUNT)
            if (this.postModel.refundModel.PAY_ACCOUNT != '') {
              console.log(this.postModel.refundModel.PAY_ACCOUNT)
               sendRequest({
                requestType: "GET", //接口 是 get 还是post
                url: "/refund/isSamePerson", //接口地址
                isBody: false, // 必填get传false ,post传true
                body: {}, //post 接口的参数
                params: {
                  orderNo: this.orderCode,
                  name: this.postModel.refundModel.PAY_ACCOUNT,
                  isHaveFile:this.postModel.refundModel.IS_REFUND_ONESELF=='1'&&this.postModel.refundContractPath && this.postModel.refundContractPath.length > 0 ? 1:this.postModel.refundModel.IS_REFUND_ONESELF=='0'&&this.postModel.deathFilePath && this.postModel.deathFilePath.length > 0 && this.postModel.relationshipFilePath.length > 0 ? 1 :this.postModel.refundModel.IS_REFUND_ONESELF==null&&this.postModel.deathFilePath && this.postModel.deathFilePath.length > 0 && this.postModel.relationshipFilePath.length > 0 ? 1: 2
                },
              }).then((res) => {
                console.log('0000',res)
                if (res.code === 20000) {
                  if(res.flag == false){
                    if(res.message.indexOf('关系证明') >-1 || res.message.indexOf('死亡证明') >-1){
                      this.is_show_enclosure = true;
                    }else {
                      this.is_show_enclosure = false
                    }
                    Toast(res.message);
                  }else {
                    this.submitRefundFun(_data);
                  }
                } else {
                  Toast(res.message);
                }
              });
            }
          } else {
            this.submitRefundFun(_data);
          }
         }, 1000);
        }).catch((err) => {
          Toast(err.message);
        });
    },
    async submitRefundFun(_data) {
      let submitData = await sendRequest(_data);
      if (submitData.code === 20000) {
        Toast(submitData.message);
        if (isiOS) {
          window.webkit.messageHandlers.JSCallNative.postMessage({
            message: "submitSuccess",
          });
        } else {
          window.android.JSCallNative(
            JSON.stringify({ message: "submitSuccess" })
          );
        }
      }
    },
    //下拉选展示
    selectPopupData(name, checkName, type) {
      //选中类型
      var txt = '';
      if(type == 1){
        txt = this.postModel.refundModel.REFUND_TYPE;
      }else if(type == 2){
        txt = this.postModel.refundModel.REFUND_PROCESS_NAME;
      }else if(type == 3){
        txt = this.postModel.refundModel.PAY_TYPE;
      }
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ type: type,text:txt});
      } else {
        window.android.JSCallNative(JSON.stringify({ type: type,text:txt}));
      }
    },
    //关闭弹出窗
    closePopup(val) {
      if (this.selectData.selectValue == "REFUND_TYPE") {
        this.postModel.refundModel.REFUND_REASON = val;
      }
      this.postModel.refundModel[this.selectData.selectValue] = val;
      this.selectData.showSelector = false;
    },
    //上传
    afterReadFun(type) {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          type: type,
        });
      } else {
        window.android.JSCallNative(JSON.stringify({ type: type }));
      }
    },

    afterRead(listArr) {
      if(this.postModel.refundModel.ID != null && this.postModel.refundModel.ID != '') { //保存之后调用
        sendRequest({
          requestType: "POST",
          url: "/BuLimsSamplingList/samplingFileCon",
          params: {},
          isBody: true,
          body: {
            samplingId: this.postModel.refundModel.ID,
            flag: listArr.type,
            userCode: listArr.code,
            userName: listArr.name,
            baseFileInfo: listArr.list,
          },
        }).then((resa)=>{
          // eslint-disable-next-line no-unused-vars
          if (resa.code === 20000) {
            this.getSelectFilePath();
          }
        })
      }else {
        sendRequest({
          requestType: "POST",
          url: "/refund/saveOrUpdate",
          params: {},
          isBody: true,
          body: { ...this.postModel },
        }).then((res)=>{
          if(res.code == 20000){
            this.postModel.refundModel.ID = res.data;
            sendRequest({
              requestType: "POST",
              url: "/BuLimsSamplingList/samplingFileCon",
              params: {},
              isBody: true,
              body: {
                samplingId: this.postModel.refundModel.ID,
                flag: listArr.type,
                userCode: listArr.code,
                userName: listArr.name,
                baseFileInfo: listArr.list,
              },
            }).then((resa)=>{
              // eslint-disable-next-line no-unused-vars
              if (resa.code === 20000) {
                this.getSelectFilePath();
              }
            })
          }
        })
      }
    },
    //删除附件
    async deleteImg(file) {
      let _data = {
        requestType: "GET",
        url: "/limsOrderTable/deleteFile",
        params: { fileId: file.ID },
        isBody: false,
        body: {},
      };
      let { data, code } = await sendRequest(_data);
      if (code === 20000) {
        this.getSelectFilePath();
      }
    },
  },
};
</script>

<style lang="less" scoped>
// .headBg {
//   width: 100%;
//   height: 128px;
//   background-image: url('../../../assets/refundBg.png');
//   background-size: 100% 100%;
//   position: absolute;
//   top: 0;
// }
.refund-style {
  // font-family: PingFangSC-Medium, PingFang SC;
  /*  background: rgb(255 255 255 / 0%);*/
  padding: 0 16px;
  .refund-style-padding {
    position: relative;
    padding-top: 20px;
  }
  .header-cont {
    h4 {
      line-height: 22px;
      font-size: 15px;
      font-weight: 500;
      color: #2f354d;
      .van-icon-arrow-left {
        width: 14px;
        height: 16px;
        margin-right: 14px;
      }
    }
  }
  .order-amount {
    height: 60px;
    background: #f4f8fd;
    border-radius: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #2F354D;
    font-size: 15px;
    span:nth-of-type(1){
      color: #9095A7;
      font-weight: 400;
      padding-left: 24px;
    }
    span:nth-of-type(2){
      color: #2F354D;
      font-weight: 400;
      padding-right: 24px;
    }
    .van-cell {
      padding: 10px 24px;
      position: relative;
      top: 10px;
      background: #fff0;  
      font-size: 15px;
      /deep/ .van-field__control--right {
        color: #2f354d;
      }
      /deep/.van-field__label{
       color:#9095A7
      }
    }
  }
  .order-info {
    background: #f4f8fd;
    border-radius: 10px;
    height: 100%;
    margin-bottom: 120px;
    padding-bottom: 10px;
    .info-title {
      height: 70px;
      line-height: 70px;
       font-family: PingFangSC-Medium, PingFang SC;
      color: #2f354d;
      font-size: 18px;
      padding: 0 24px;
    }
    .info-bot {
      height: 20px;
      background: linear-gradient(
        360deg,
        rgba(58, 74, 134, 0) 0%,
        rgba(58, 74, 134, 0.06) 100%
      );
    }
    .info-cont {
      .info-form {
        padding: 0 24px;
      }
      .title-label {
        font-size: 13px;
        color: #2f354d;
        i {
          color: #ff627f;
          font-style: normal;
          margin-left: 4px;
          position: relative;
          top: 2px;
        }
      }
      .info-input {
        color: #2f354d;
        font-size: 15px;
        position: relative;
        i {
          font-style: normal;
          font-weight: 400;
          color: #2f354d;
          font-size: 18px;
          position: absolute;
          top: 12px;
        }
        .van-cell {
          font-size: 15px;
          background: #fff0;
          padding: 12px 0 10px 16px;
          border-bottom: 1px solid #e3e5e8;
          margin-bottom: 24px;
          /deep/ .van-field__body {
            input {
              text-indent: 10px;
              color: #2f354d;
            }
          }
        }
        .van-field--error {
          margin-bottom: 14px;
          border-bottom: none;
          /deep/ .van-field__control::placeholder {
            color: #c8c9cc;
          }
          /deep/ .van-field__control {
            color: #2f354d;
          }
          /deep/ .van-field__error-message {
            color: #ff627f;
            font-size: 13px;
            text-align: left;
            border-top: 1px solid #ff627f;
            padding-top: 6px;
            margin-top: 10px;
            line-height: 18px;
            margin-left: -16px;
          }
        }
      }
      .info-input-new {
        position: relative;
        .icon-saoyisao{
          position: absolute;
          right: 0;
          top: 15px;
        }
        .van-cell {
          padding-left: 0;
          /deep/ .van-field__body {
            input {
              text-indent: 0;
            }
          }
        }

        .van-field--error {
          /deep/ .van-field__error-message {
            margin-left: 0;
          }
        }
      }
      .info-input-bottom {
        .van-cell {
          margin-bottom: 10px;
        }
      }
      .refund-tip {
        font-size: 11px;
        font-weight: 400;
        color: #9095a7;
        line-height: 16px;
        padding-bottom: 22px;
      }
    }
  }
  .info-btns {
    display: flex;
    position: fixed;
    bottom: 54px;
    button:first-child {
      border: none;
      font-size: 15px;
      font-weight: 400;
      color: #5f697d;
      letter-spacing: 1px;
      margin: 0 12px 0 8px;
      background: #ffffff;
      box-shadow: 0 6px 20px -2px rgba(52, 68, 132, 0.15);
      width: 100px;
    }
    button:last-child {
      background: linear-gradient(90deg, #6f9cff 0%, #4b84ff 100%);
      box-shadow: 0 6px 20px -2px rgba(75, 132, 255, 0.3);
      font-size: 15px;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 1px;
      width: 214px;
    }
  }
}
/deep/.van-overlay {
  background-color: #00000000;
}
/deep/.van-popup {
  box-shadow: 1px 0px 38px 20px #0000002b;
}
.upload-list {
  padding-top: 12px;
  /deep/.van-image,
  .upload-btn {
    width: 90px;
    height: 90px;
    border-radius: 4px;
    overflow: hidden;
    background: #ffffff;
  }
  .upload-btn {
    margin: 5px 5px 0 0;
  }
  .upload-btn {
    text-align: center;
    color: #4b84ff;
    display: inline-block;
    span:first-child {
      width: 14px;
      height: 13px;
      display: block;
      margin: 27px auto 6px;
    }
    span:last-child {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }
  .imgArrClass {
    width: 90px;
    height: 90px;
    position: relative;
    margin: 5px 5px 0 0;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;

    .deleteImgStyle {
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0px 4px 0px 4px;
      color: #fff !important;
      font-size: 12px !important;
      display: inline-block;
      font-style: normal;
      text-align: center;
      line-height: 20px;
      position: absolute;
      right: 0;
    }
  }

  /deep/ .van-uploader__preview {
    margin: 5px 5px 0 0;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    .van-uploader__preview-image {
      width: 90px;
      height: 90px;
    }
    .van-uploader__preview-delete {
      width: 20px;
      height: 20px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0px 4px 0px 4px;
      text-align: center;
      .van-uploader__preview-delete-icon {
        top: 1px;
        right: 1px;
        font-size: 18px;
      }
    }
  }
  /deep/ .van-uploader__input-wrapper {
    width: 90px;
    height: 90px;
    background: #ffffff;
    border-radius: 4px;
    text-align: center;
    color: #4b84ff;
    margin-top: 5px;
    span:first-child {
      width: 14px;
      height: 13px;
      display: block;
      margin: 27px auto 6px;
    }
    span:last-child {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
  }
}
/deep/input::placeholder{
  color: #A4A9BF;
}
  .cost_reson {
    width: 295px;
    height: 32px;
    background: #ebeff7;
    border-radius: 4px;
    display: flex;
    button {
      width: 50%;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      background: #ebeff7;
    }
    .isChecked {
      width: 50%;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(52, 68, 132, 0.1);
      border-radius: 4px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4b84ff;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
